import { Injectable } from '@angular/core';
import { get, flatten } from 'lodash';
import { ReplyItem, Survey, Question, Check } from '../../classes';
import { DatePipe } from '@angular/common';
import { ExcelService } from '@schoolbelle/common/excel';
import { PhoneNumberPipe } from '@schoolbelle/common/phone-number';

@Injectable({
  providedIn: 'root',
})
export class TableService {

  constructor(
    private datePipe:DatePipe,
    private phoneNumberPipe:PhoneNumberPipe,
    private excel:ExcelService,
  ) { 
  }


  downloadAsExcel (survey:Survey, list:ReplyItem[], title:string = 'ì¤ë¬¸ê²°ê³¼') {
    this.excel.download(this.toExcelData(survey, list), title);
  }
  private toExcelData (survey:Survey, list:ReplyItem[]) {
    const rows:string[][] = [];

    rows.push(['ì ì²´íµê³']);
    rows.push(['ë¬¸í­','ì íì§', 'ì¸ì(ëª)']);
    survey.questions.forEach((q)=>{
      q.options.forEach((o, i)=>{
        const count = list.filter(li=>get(li, ['snapshot', q.id, o.id]) ? true : false).length;
        rows.push([i === 0 ? q.text : undefined, o.text, count.toString()]);
      });
    });
    const text_options = flatten(survey.questions.map(q=>q.options.filter(o=>o.type === 'text')));
    if (text_options.length > 0) {
      rows.push([]);
      rows.push(['ì£¼ê´ì']);
      text_options.forEach((o, option_index)=>{
          const answerlist = list.filter(li=>get(li, ['snapshot', o.question.id, o.id]) ? true : false).map(li=>get(li, ['snapshot', o.question.id, o.id, 'value']));
          answerlist.forEach((answer, answer_index)=>{
            rows.push([
              option_index === 0 && answer_index === 0 ? o.question.text : undefined, 
              answer_index === 0 ? o.text : undefined, 
              answer,
            ]);
          })
      })    
    }
    rows.push([]);
    rows.push(['ê°ë³ìëµ']);
    rows.push(['ì ì¶ìê°', 'ì´ë¦', 'ì°ë½ì²', 'ì´ë©ì¼', ...survey.questions.map(q=>q.text)]);
    list.forEach(li=>{
      const answers = survey.questions.map(q=>this.summaryQuestionAnswer(li, q));
      rows.push([
        this.datePipe.transform(li.timestamp, 'MM-dd HH:mm:ss') || '', 
        li.displayName, 
        this.phoneNumberPipe.transform(li.phoneNumber) || '', 
        li.email, 
        ...answers
      ])
    })
    return rows;
  }
  private summaryQuestionAnswer (item:ReplyItem, question:Question) {
    return question.options.map(o=>{
      const check:Check = get(item, ['snapshot', question.id, o.id]);
      if (check) {
        if (o.type === 'text') return check.value;
        else return o.text; 
      }
      else return undefined;
    }).filter(v=>v).join(',');

  }
}
